var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.disabledSaved
    ? _c("c-loader", {
        staticClass: "new-calculation-loader",
        attrs: {
          label: "Производится сохранение",
          active: _vm.disabledSaved,
          height: 500,
        },
      })
    : _c(
        "div",
        { staticClass: "production" },
        [
          _c("m-table-settings", {
            attrs: {
              columns: _vm.tableData.columns,
              "disabled-columns": _vm.tableData.disabledColumns,
              "default-disabled-columns": _vm.tableData.defaultDisabledColumns,
              "with-grouped": "",
            },
            on: { submit: _vm.submitTableSettings },
            model: {
              value: _vm.tableSettingsModal,
              callback: function ($$v) {
                _vm.tableSettingsModal = $$v
              },
              expression: "tableSettingsModal",
            },
          }),
          _c("m-production-posts", {
            attrs: {
              active: _vm.isShowModalProductionsPosts,
              posts: _vm.postsLocal,
              "table-records": _vm.tableData.records,
            },
            on: {
              submitPosts: _vm.submitPosts,
              close: function ($event) {
                _vm.isShowModalProductionsPosts = false
              },
            },
          }),
          _c("m-production-add-workers", {
            attrs: {
              "modal-title": "Добавить сотрудников",
              active: _vm.isShowModalProductionsAddWorkers,
              workers: _vm.productionAddWorkersModalItems,
              selected: _vm.productionAddWorkersModalItemsSelected,
              "is-calc-first-load": _vm.isCalcFirstLoad,
              "table-records": _vm.tableData.records,
              tab: _vm.tab,
              data: _vm.data,
              "group-code": _vm.productionAddWorkersModalGroupCode,
            },
            on: {
              submitWorkers: _vm.submitWorkers,
              close: function ($event) {
                _vm.isShowModalProductionsAddWorkers = false
              },
            },
          }),
          _c("m-production-add-workers-all", {
            attrs: {
              active: _vm.isShowModalProductionsAddWorkersAll,
              workers: _vm.productionAddWorkersAllModalItems,
              selected: _vm.productionAddWorkersAllModalItemsSelected,
              posts: _vm.postsLocal,
              tab: _vm.tab,
              "table-records": _vm.tableData.records,
              data: _vm.data,
            },
            on: {
              submitWorkers: _vm.submitWorkers,
              close: function ($event) {
                _vm.isShowModalProductionsAddWorkersAll = false
              },
            },
          }),
          _c("m-production-write-fine-premium", {
            attrs: {
              "calculation-type": _vm.tab,
              "calc-data": _vm.data,
              "table-records": _vm.tableData.records,
              active: _vm.isShowModalProductionWriteFinePremium,
            },
            on: {
              writeFineBonusAllWorkers: _vm.writeFineBonusAllWorkers,
              close: function ($event) {
                _vm.isShowModalProductionWriteFinePremium = false
              },
            },
          }),
          _c("m-production-create-worker", {
            attrs: {
              "modal-title": "Создать сотрудника",
              active: _vm.isShowModalProductionCreateWorker,
              "calculation-type": _vm.tab,
              data: _vm.data,
            },
            on: {
              close: function ($event) {
                _vm.isShowModalProductionCreateWorker = false
              },
              createNewWorker: _vm.createNewWorker,
            },
          }),
          _c("m-position-intervals", { ref: "positionIntervalsModal" }),
          _c("div", { staticClass: "production-header" }, [
            _c(
              "div",
              { staticClass: "production-header-buttons-left" },
              [
                _c("c-button-dropdown", {
                  staticClass: "production-header-buttons-left-employee",
                  class: {
                    "production-header-buttons-left-employee-disabled":
                      _vm.dataIsLoading || !_vm.canEdit,
                  },
                  attrs: {
                    disabled: _vm.dataIsLoading || !_vm.canEdit,
                    icon: "arrow",
                    type: "dropdown",
                    label: "Сотрудники",
                    dropdown: {
                      position: "right",
                      items: [
                        { label: "Добавить сотрудников", emit: "addWorkers" },
                        { label: "Новый сотрудник", emit: "createWorker" },
                        { label: "Добавить всех", emit: "addWorkersAll" },
                      ],
                    },
                  },
                  on: {
                    addWorkers: _vm.openAddWorkersAllModal,
                    addWorkersAll: _vm.addWorkersAll,
                    createWorker: _vm.openCreateWorkerModal,
                  },
                }),
                _c("c-button", {
                  staticClass: "production-header-buttons-left-post",
                  attrs: {
                    label: "Должности",
                    disabled: _vm.dataIsLoading || !_vm.canEdit,
                    color: "white",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowModalProductionsPosts = true
                    },
                  },
                }),
                _c("c-button", {
                  staticClass: "production-header-buttons-left-fine-rewarding",
                  attrs: {
                    label:
                      _vm.tab === "byPeriod"
                        ? "Штраф/премия"
                        : "Штраф/премия смене",
                    disabled:
                      !_vm.isThereWorkersInTable ||
                      _vm.dataIsLoading ||
                      !_vm.canEdit,
                    color: "white",
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowModalProductionWriteFinePremium = true
                    },
                  },
                }),
                _vm.$route.query.calc_id
                  ? _c("c-select", {
                      staticClass:
                        "production-header-buttons-left-fine-rewarding production-header-select",
                      attrs: {
                        type: "select",
                        placeholder: "Версия расчета",
                        items: _vm.getCalcVersions,
                      },
                      model: {
                        value: _vm.currentCalcVersion,
                        callback: function ($$v) {
                          _vm.currentCalcVersion = $$v
                        },
                        expression: "currentCalcVersion",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "production-header-buttons-right" },
              [
                _c("c-button", {
                  attrs: {
                    responsive: "",
                    size: "small",
                    disabled: _vm.dataIsLoading || !_vm.canEdit,
                    label: "Настроить столбцы",
                    icon: "cog",
                    type: "with-icon",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openColumnSettingsModalClick()
                    },
                  },
                }),
                _c("c-button", {
                  staticClass: "production-header-buttons-right-less",
                  attrs: {
                    label: "Меньше информации",
                    disabled: _vm.dataIsLoading || _vm.currentColumnLevel === 1,
                    icon: "less",
                    color: "white",
                    size: "small",
                  },
                  on: { click: _vm.lessInformation },
                }),
                _c("c-button", {
                  staticClass: "production-header-buttons-right-more",
                  attrs: {
                    label: "Больше информации",
                    icon: "more",
                    disabled: _vm.dataIsLoading || _vm.currentColumnLevel === 3,
                    color: "white",
                    size: "small",
                  },
                  on: { click: _vm.moreInformation },
                }),
              ],
              1
            ),
          ]),
          !_vm.dataIsLoading
            ? _c("c-data-table-create-calculations-production", {
                ref: "table",
                staticClass: "production-table",
                attrs: {
                  levels: 1,
                  "disabled-columns": _vm.tableData.disabledColumns,
                  "is-filial-admin": _vm.isFilialAdmin,
                  data: _vm.tableData,
                  "calculation-data": _vm.data,
                  "calculate-type": _vm.tab,
                  "personal-reasons": _vm.personalReasons,
                  "user-columns": _vm.productionColumns,
                  "premium-personal-account-loading":
                    _vm.premiumPersonalAccountLoading,
                  "loading-item": _vm.loadingItem,
                  bonusesForExceeded: _vm.bonusesForExceeded,
                  "can-edit": _vm.canEdit,
                },
                on: {
                  productionRemoveWorkerFromCalc: _vm.removeWorker,
                  showModalAddWorkers: _vm.showModalAddWorkers,
                  showPositionIntervalsModal: _vm.showPositionIntervalsModal,
                  updateKPItable: _vm.updateKPItable,
                  updateFines: _vm.updateFines,
                  updateRank: _vm.updateRank,
                  updateCompensation: _vm.updateCompensation,
                  updateBonuses: _vm.updateBonuses,
                  updatePersonal: _vm.updatePersonal,
                },
              })
            : _vm._e(),
          !_vm.dataIsLoading && (_vm.canEdit || _vm.canClose || _vm.isClosed)
            ? _c(
                "div",
                { staticClass: "production-actions-row" },
                [
                  _vm.canClose
                    ? _c("c-button", {
                        staticClass: "production-actions-row__toggle-closed",
                        class: {
                          "production-actions-row__toggle-closed--active":
                            !_vm.isClosed,
                        },
                        attrs: {
                          size: "large",
                          disabled: _vm.isTogglingClosed,
                          label: _vm.isClosed
                            ? "Открыть расчёт"
                            : "Закрыть расчёт",
                          color: _vm.isClosed ? "primary" : undefined,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("toggleClosed")
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.isClosed
                    ? _c(
                        "span",
                        { staticClass: "production-actions-row__closed-badge" },
                        [_vm._v("Расчёт закрыт")]
                      )
                    : _vm._e(),
                  _vm.canEdit
                    ? _c("responsive-apply-reset-actions", {
                        staticClass: "production-actions",
                        class: { "no-shadow": !_vm.displayActionShadows },
                        attrs: { "disable-submit": _vm.disabledSaved },
                        on: {
                          "on-submit": _vm.saveCalculation,
                          "on-reset": _vm.cancelCalculation,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.dataIsLoading
            ? _c("c-loader", {
                staticClass: "production-loader",
                attrs: {
                  label: "Данные загружаются",
                  active: _vm.dataIsLoading,
                  height: "300",
                },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }